import React from "react";
import Group79 from "../subcomponents/Group79";
import Frame77 from "../subcomponents/Frame77";
import Group77 from "../subcomponents/Group77";

const Frame78 = () => {
      return(
            <div className="group-parent">
                  <Group79 />
                  <div className="frame-parent">
                        <Frame77 />
                        <Group77 />
                  </div>
            </div>
      );
};

export default Frame78;